import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/store';
import * as actions from '@redux-actions/';
import SavedPrescriptionCardContent from './SavedPrescriptionCardContent';
import SavedPrescriptionCard from './SavedPrescriptionCard';
import LoaderElement from '@loaders/LoaderElement';

const MySavedPrescriptions = (): JSX.Element => {
    const mySavedPrescriptions = useSelector(
        (state: RootState) => state.contacts.mySavedPrescriptions
    );
    const getMySavedPrescriptionsRequestStatus = useSelector(
        (state: RootState) => state.contacts.getMySavedPrescriptionsRequestStatus
    );
    const currentPrescription = useSelector(
        (state: RootState) => state.contacts.currentPrescription
    );

    const dispatch = useDispatch();

    useEffect(() => {
        if (mySavedPrescriptions?.length === 1)
            dispatch(actions.setCurrentPrescription(mySavedPrescriptions[0]));
    }, [mySavedPrescriptions]);

    return (
        <div className="logged-select-prescription">
            {!!currentPrescription && <SavedPrescriptionCardContent />}

            {!currentPrescription && (
                <div className="cards-container">
                    {getMySavedPrescriptionsRequestStatus === 'SUCCESS' ? (
                        mySavedPrescriptions?.map((p, i) => (
                            <SavedPrescriptionCard prescription={p} key={i} />
                        ))
                    ) : (
                        <>
                            <LoaderElement height={96} />
                            <LoaderElement height={96} />
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default MySavedPrescriptions;
